import { withJoinBiEnhancerProps } from 'viewModel/enhancedMarkdown/joinBiEnhancer/withJoinBiEnhancerProps';
import JoinBiEnhancer from 'components/EnhancedMarkdown/JoinBiEnhancer/JoinBiEnhancer';

export default withJoinBiEnhancerProps(JoinBiEnhancer);
